import { v4 as uuidV4 } from 'uuid';
import StorageUtils from '@spothero/utils/storage';
import { StorageDurations, StorageKeys, StorageTypes, } from 'common/constants/storageKeys';
export const SEARCH_TRACKING_ACTIONS = {
    SEARCH: 'SEARCH',
    EVENT: 'EVENT',
    VEHICLE_CHANGED: 'VEHICLE_CHANGED',
    DATE_CHANGED: 'DATE_CHANGED',
    FIND_ME: 'FIND_ME',
    LIST_SEARCH: 'LIST_SEARCH',
    LIST_EVENT: 'LIST_EVENT',
    LIST_DATE_CHANGED: 'LIST_DATE_CHANGED',
    LIST_SEARCH_NEXT: 'LIST_SEARCH_NEXT',
    LOYALTY_PROGRAM_FILTER_CHANGED: 'LOYALTY_PROGRAM_FILTER_CHANGED',
    PAN: 'PAN',
    ZOOM: 'ZOOM',
    AUTOZOOM: 'AUTOZOOM',
    UNAVAILABLE_SHOW_NEARBY: 'UNAVAILABLE_SHOW_NEARBY',
};
const NEW_SEARCH_INTENT_ACTIONS = [
    SEARCH_TRACKING_ACTIONS.SEARCH,
    SEARCH_TRACKING_ACTIONS.EVENT,
    SEARCH_TRACKING_ACTIONS.DATE_CHANGED,
    SEARCH_TRACKING_ACTIONS.FIND_ME,
    SEARCH_TRACKING_ACTIONS.LIST_SEARCH,
    SEARCH_TRACKING_ACTIONS.LIST_EVENT,
    SEARCH_TRACKING_ACTIONS.LIST_DATE_CHANGED,
    SEARCH_TRACKING_ACTIONS.VEHICLE_CHANGED,
    SEARCH_TRACKING_ACTIONS.LOYALTY_PROGRAM_FILTER_CHANGED,
];
/**
 * Utility for tracking user search behavior.
 * @module SearchTracking
 * @see {@link https://spothero.atlassian.net/wiki/spaces/FE/pages/1313964582/Search+Tracking} for overall documentation on Search Tracking within Consumer Web
 */
const SearchTracking = {
    updateAction(actionName = SEARCH_TRACKING_ACTIONS.SEARCH) {
        StorageUtils.remove(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_UUID_COOKIE, StorageTypes.COOKIE);
        // Does our new actionName correspond to a new search intent?
        if (NEW_SEARCH_INTENT_ACTIONS.find(action => action === actionName)) {
            StorageUtils.remove(StorageKeys.SEARCH_TRACKING.COOKIES.SEARCH_UUID_COOKIE, StorageTypes.COOKIE);
        }
        StorageUtils.set(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_COOKIE, actionName, StorageTypes.COOKIE, StorageDurations.HALF_HOUR_IN_DAYS);
    },
    getValues() {
        const sessionUUIDCookie = StorageUtils.get(StorageKeys.SEARCH_TRACKING.COOKIES.SESSION_UUID_COOKIE, StorageTypes.COOKIE);
        const searchUUIDCookie = StorageUtils.get(StorageKeys.SEARCH_TRACKING.COOKIES.SEARCH_UUID_COOKIE, StorageTypes.COOKIE);
        const actionUUIDCookie = StorageUtils.get(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_UUID_COOKIE, StorageTypes.COOKIE);
        const actionCookie = StorageUtils.get(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_COOKIE, StorageTypes.COOKIE);
        const sessionUUID = sessionUUIDCookie
            ? sessionUUIDCookie
            : uuidV4();
        const searchUUID = sessionUUIDCookie && searchUUIDCookie && /\S/.test(searchUUIDCookie) // cookie is not empty and not just whitespace
            ? searchUUIDCookie
            : uuidV4();
        const actionUUID = sessionUUIDCookie && searchUUIDCookie && actionUUIDCookie
            ? actionUUIDCookie
            : uuidV4();
        const action = actionCookie
            ? actionCookie
            : SEARCH_TRACKING_ACTIONS.SEARCH;
        StorageUtils.set(StorageKeys.SEARCH_TRACKING.COOKIES.SESSION_UUID_COOKIE, sessionUUID, StorageTypes.COOKIE, StorageDurations.HALF_HOUR_IN_DAYS);
        StorageUtils.set(StorageKeys.SEARCH_TRACKING.COOKIES.SEARCH_UUID_COOKIE, searchUUID, StorageTypes.COOKIE, StorageDurations.HALF_HOUR_IN_DAYS);
        StorageUtils.set(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_UUID_COOKIE, actionUUID, StorageTypes.COOKIE, StorageDurations.HALF_HOUR_IN_DAYS);
        StorageUtils.set(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_COOKIE, action, StorageTypes.COOKIE, StorageDurations.HALF_HOUR_IN_DAYS);
        return {
            sessionUUID,
            searchUUID,
            actionUUID,
            action,
        };
    },
    destroySession() {
        StorageUtils.remove(StorageKeys.SEARCH_TRACKING.COOKIES.SESSION_UUID_COOKIE, StorageTypes.COOKIE);
        StorageUtils.remove(StorageKeys.SEARCH_TRACKING.COOKIES.SEARCH_UUID_COOKIE, StorageTypes.COOKIE);
        StorageUtils.remove(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_UUID_COOKIE, StorageTypes.COOKIE);
        StorageUtils.remove(StorageKeys.SEARCH_TRACKING.COOKIES.ACTION_COOKIE, StorageTypes.COOKIE);
    },
};
export default SearchTracking;
